export default __webpack_public_path__ + "assets/435b1bef96c79093c441f263d42d8c23.png";